import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ext, fileClass, progressOf, statusFor, targetCodes } from './projectHelpers';

const COLS = 11;
const COL_DAYS = 3;

const tlBg = (s) => ({
    live: 'var(--accent-soft)',
    queued: 'var(--bg-soft)',
    review: 'var(--yellow-soft)',
    done: 'var(--indigo-soft)',
    blocked: '#fbe1e1',
}[s] || 'var(--bg-soft)');

const tlFg = (s) => ({
    live: 'var(--accent)',
    queued: 'var(--ink-3)',
    review: '#a87a14',
    done: 'var(--indigo)',
    blocked: '#b53e3e',
}[s] || 'var(--ink-3)');

const buildDays = () => {
    const days = [];
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    start.setDate(start.getDate() - COL_DAYS); // a couple days back, then forward
    for (let i = 0; i < COLS; i += 1) {
        const d = new Date(start);
        d.setDate(start.getDate() + i * COL_DAYS);
        days.push(d);
    }
    return days;
};

const fmt = (d) => d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });

const TimelineView = ({ rows }) => {
    const navigate = useNavigate();
    const days = buildDays();
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayIdx = days.findIndex((d) => d.getTime() >= today.getTime());

    const slots = rows.map((p, i) => {
        const start = (i * 2) % (days.length - 3);
        let span = 2;
        const pct = progressOf(p);
        if (pct > 60) span += 1;
        if (targetCodes(p).length > 3) span += 1;
        return { p, start, span: Math.min(span, days.length - start) };
    });

    return (
        <div className="rs-card flat" style={{ padding: 16 }}>
            <div style={{ display: 'grid', gridTemplateColumns: `260px repeat(${days.length}, 1fr)`, gap: 4, alignItems: 'center' }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-4)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                    Project
                </span>
                {days.map((d, i) => (
                    <span
                        key={i}
                        style={{
                            fontSize: 10.5,
                            fontWeight: 600,
                            color: i === todayIdx ? 'var(--accent)' : 'var(--ink-4)',
                            textAlign: 'center',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            padding: '6px 0',
                            borderBottom: i === todayIdx ? '1px solid var(--accent)' : '1px solid var(--line)',
                        }}
                    >
                        {fmt(d)}
                    </span>
                ))}
                {slots.map(({ p, start, span }) => {
                    const e = ext(p);
                    const status = statusFor(p);
                    const pct = progressOf(p);
                    return (
                        <React.Fragment key={p._id}>
                            <div
                                onClick={() => navigate(`/dashboard/projects/${p._id}`)}
                                role="button"
                                tabIndex={0}
                                style={{ padding: '8px 4px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px dashed var(--line)', cursor: 'pointer' }}
                            >
                                <span className={`fic ${fileClass(e)}`} style={{ width: 22, height: 22, borderRadius: 5, fontSize: 9, display: 'grid', placeItems: 'center', fontWeight: 700 }}>{e}</span>
                                <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.name}</span>
                            </div>
                            {Array.from({ length: days.length }).map((_, i) => {
                                if (i < start) return <span key={i} style={{ borderBottom: '1px dashed var(--line)' }} />;
                                if (i === start) {
                                    return (
                                        <div key={i} style={{ gridColumn: `span ${span}`, padding: '8px 0', borderBottom: '1px dashed var(--line)', display: 'flex', alignItems: 'center' }}>
                                            <div
                                                style={{
                                                    height: 22,
                                                    width: '100%',
                                                    borderRadius: 6,
                                                    padding: '0 8px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 6,
                                                    fontSize: 10.5,
                                                    fontWeight: 600,
                                                    background: tlBg(status),
                                                    color: tlFg(status),
                                                }}
                                            >
                                                <span style={{ width: 5, height: 5, borderRadius: 999, background: 'currentColor' }} />
                                                <span style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    {pct}% · {targetCodes(p).length} lang
                                                </span>
                                            </div>
                                        </div>
                                    );
                                }
                                if (i > start && i < start + span) return null;
                                return <span key={i} style={{ borderBottom: '1px dashed var(--line)' }} />;
                            })}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default TimelineView;
